enum TipoMovimentacaoEnum{
	POSITIVO = "POSITIVO",
	NEGATIVO = "NEGATIVO",
	TODOS = "TODOS"
}

export { TipoMovimentacaoEnum };
